import { DocumentTheme } from "../types/documentTypes";

// Define theme presets with proper TypeScript types
export const themePresets: Record<string, DocumentTheme> = {
  professional: {
    headingColor: "#1a365d",
    subheadingColor: "#2a4365",
    textColor: "#2d3748",
    backgroundColor: "#ffffff",
    fontFamily: "Inter, system-ui, -apple-system, sans-serif",
    headingSize: "medium",
    textSize: "medium",
    header: {
      enabled: true,
      type: "simple",
      includePageNumbers: true,
    },
    footer: {
      enabled: true,
      type: "simple",
      includePageNumbers: true,
    },
    showCoverPage: true,
  },
  modern: {
    headingColor: "#047857",
    subheadingColor: "#059669",
    textColor: "#1f2937",
    backgroundColor: "#ffffff",
    fontFamily: "Inter, system-ui, -apple-system, sans-serif",
    headingSize: "medium",
    textSize: "medium",
    header: {
      enabled: true,
      type: "simple",
      includePageNumbers: true,
    },
    footer: {
      enabled: true,
      type: "simple",
      includePageNumbers: true,
    },
    showCoverPage: true,
  },
  creative: {
    headingColor: "#3790c5",
    subheadingColor: "#3790c5",
    textColor: "#374151",
    backgroundColor: "#ffffff",
    fontFamily: "Inter, system-ui, -apple-system, sans-serif",
    headingSize: "medium",
    textSize: "medium",
    header: {
      enabled: true,
      type: "simple",
      includePageNumbers: true,
    },
    footer: {
      enabled: true,
      type: "simple",
      includePageNumbers: true,
    },
    showCoverPage: true,
  },
  formal: {
    headingColor: "#1f2937",
    subheadingColor: "#374151",
    textColor: "#4b5563",
    backgroundColor: "#ffffff",
    fontFamily: "Inter, system-ui, -apple-system, sans-serif",
    headingSize: "medium",
    textSize: "medium",
    header: {
      enabled: true,
      type: "simple",
      includePageNumbers: true,
    },
    footer: {
      enabled: true,
      type: "simple",
      includePageNumbers: true,
    },
    showCoverPage: true,
  },
};
